export const dataHooks = {
    SUFFIX: 'list-item-section-suffix',
    TITLE: 'list-item-section-title',
};
//# sourceMappingURL=constants.js.map